export const GET_REWARDS_REQUEST = 'GET_REWARDS_REQUEST';
export const GET_REWARDS_SUCCESS = 'GET_REWARDS_SUCCESS';
export const GET_REWARDS_FAILED = 'GET_REWARDS_FAILED';

export const CREATE_REWARD_REQUEST = 'CREATE_REWARD_REQUEST';
export const CREATE_REWARD_SUCCESS = 'CREATE_REWARD_SUCCESS';
export const CREATE_REWARD_FAILED = 'CREATE_REWARD_FAILED';

export const GET_REWARD_REQUEST = 'GET_REWARD_REQUEST';
export const GET_REWARD_SUCCESS = 'GET_REWARD_SUCCESS';
export const GET_REWARD_FAILED = 'GET_REWARD_FAILED';

export const UPDATE_REWARD_REQUEST = 'UPDATE_REWARD_REQUEST';
export const UPDATE_REWARD_SUCCESS = 'UPDATE_REWARD_SUCCESS';
export const UPDATE_REWARD_FAILED = 'UPDATE_REWARD_FAILED';

export const CLEAR_REWARD = 'CLEAR_REWARD';
